import React from "react";
import FileTag from "./filetag";
import LimitedList from "components/LimitedList";
import { ClearablePill } from "components/Atoms/ClearablePill";

interface Props {
  files: server.dto.File[]
  onAddFilesClick: () => void
  editDisabled?: boolean
}

const FileList = ({ files, onAddFilesClick, editDisabled }: Props) => <div className="flex">
  <div className="grow1">
    <div className="flex flex-wrap gap-small">
      {files.length === 0 && RESX.File.NoFilesUploaded}
      <LimitedList
        items={files}
        renderItem={file => <FileTag key={file.id} fullName={file.fullName} downloadUrl={file.downloadUrl} />}
        renderExcess={nr => <a onClick={onAddFilesClick}><ClearablePill color="blue">+{nr}</ClearablePill></a>}
        limit={5}
        delimiter=""
      />
    </div>

  </div>

  {!editDisabled && <div>
    <a className="icon-ellipsis-h" onClick={onAddFilesClick}></a>
  </div>}
</div>;

export default FileList;
